var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"digital-flop-container"},[_c('dv-border-box-1',{staticClass:"dv-border-box"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("已行驶距离")])]),_c('dv-digital-flop',{staticStyle:{"width":"auto","height":"80px"},attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }